import { combineReducers } from 'redux';

import loading from 'modules/global/reducers/generic.loading';
import {
  CLOSE_DUPLICATE_MODAL,
  OPEN_DUPLICATE_MODAL,
  POST_CLONE_GUIDELINE,
  POST_CLONE_GUIDELINE_SUCCESS,
} from 'modules/guidelines/actionTypes';
import type { OpenDuplicateModalAction, OpenDuplicateModalPayload } from 'modules/guidelines/types/actions';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const isOpen = createReducer<boolean>(false, {
  [OPEN_DUPLICATE_MODAL]: () => true,
  [CLOSE_DUPLICATE_MODAL]: () => false,
  [POST_CLONE_GUIDELINE_SUCCESS]: () => false,
  [LOCATION_CHANGE]: () => false,
});

const params = createReducer<Partial<OpenDuplicateModalPayload>>({}, {
  [OPEN_DUPLICATE_MODAL]: (_, { payload }: OpenDuplicateModalAction) => payload,
  [CLOSE_DUPLICATE_MODAL]: () => ({}),
});

export default combineReducers({
  isOpen,
  loading: loading(POST_CLONE_GUIDELINE),
  params,
});
